import React from 'react'
import { Typography } from 'antd'

const { Paragraph, Text } = Typography

export default function FormulaBlock({ lines = [] }) {
  if (!lines || lines.length === 0) return null
  return (
    <div style={{ background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 8, padding: 12 }}>
      {lines.map((l, i) => (
        <Paragraph key={i} style={{ marginBottom: 6 }}>
          <Text code style={{ fontSize: 13 }}>{l}</Text>
        </Paragraph>
      ))}
    </div>
  )
}
